// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".support-container__support-text[data-v-5b87874d]{color:#cbcbd3;width:123px}.support-container__arrow[data-v-5b87874d]{height:95px;margin-bottom:20px;margin-top:35px;-o-object-fit:cover;object-fit:cover;width:95px}.support-container__img[data-v-5b87874d]{height:160px;margin-left:auto;max-width:300px;-o-object-fit:contain;object-fit:contain}@media only screen and (max-width:576px){.support-container__img[data-v-5b87874d]{height:121px;width:228px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
